import Component from '../core/Component'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

export default class FooterVideo extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            video: null,
            source: null
        }
    }

    prepare() {
        const oneToEleven = Math.floor(Math.random() * 11) + 1;
        this.ref.source.setAttribute('src', `/files/footer/scene-${oneToEleven}.mp4`)
        this.ref.video.load()

        EventBus.on(EVENTS.SWUP_WILL_REPLACE_CONTENT, () => {
            const oneToEleven = Math.floor(Math.random() * 11) + 1;
            this.ref.source.setAttribute('src', `/files/footer/scene-${oneToEleven}.mp4`)
            this.ref.video.load()
        })
    }
}